import { TableRow as FBTableRow } from "flowbite-react";

const TableRow = (props) => {
  const tmpProps = {...props};
  if (tmpProps.error) {
    tmpProps.className = tmpProps.className + " !bg-[#fdf0f0]";
  }
  return <FBTableRow {...tmpProps}>{props.children}</FBTableRow>;
};

export default TableRow;